import type { ScanResult } from '../../types';
import { makeId, request } from '../api/client';

export const barcodeService = {
  /** Generate Code-128-style bar widths (1-4) from a numeric string. */
  generateBars(data: string): number[] {
    const bars: number[] = [];
    for (let i = 0; i < data.length; i++) {
      const code = data.charCodeAt(i);
      bars.push((code % 4) + 1, ((code >> 2) % 4) + 1);
    }
    return bars;
  },

  decode() {
    return request('/barcode/decode', () => {
      const result: ScanResult = {
        id: makeId('s'),
        type: 'barcode',
        payload: Math.floor(Math.random() * 1e12).toString().padStart(13, '0'),
        merchant: 'Whole Foods Market',
        amount: Math.round((Math.random() * 200 + 10) * 100) / 100,
        currency: 'USD',
        scannedAt: new Date().toISOString(),
      };
      return result;
    }, { delay: 1500 });
  },
};
